import { useState, useEffect } from 'react';
import { handleRequestHelper } from '../../../utils/helpers';
import api from '../../../api/api';

export const useRecommendationLists = () => {
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  const [lists, setLists] = useState([]);

  const getLists = async () => {
    await handleRequestHelper({
      endpoint: () => api.getRecommendationLists(),
      onSuccess: ({ curatedEventLists }) => {
        setLists(curatedEventLists);
      },
      showNotification: true,
    });
  };

  const handleDragEnd = (result) => {
    setEnableSaveButton(true);
    setLists(result);
  };

  const handleReOrderLists = async () => {
    const mappedLists = lists.map(({ id }) => id);
    await handleRequestHelper({
      endpoint: () => api.reOrderLists({ listIdsOrder: mappedLists }),
      onSuccess: async () => {
        await getLists();
        setEnableSaveButton(false);
      },
      showNotification: true,
    });
  };

  useEffect(() => {
    getLists();
  }, []);

  return { lists, enableSaveButton, getLists, handleDragEnd, handleReOrderLists };
};
